import {range} from '@aboutyou/utils';
import {useMemo} from 'react';
import {PRODUCTS_PER_PAGE} from '../../ProductStream/constants';
import {LoadMoreComponentDisplayConfig} from '../ProductStreamTokenPagination';

interface PaginationRangeConfig {
  initialPage: number;
  currentPage: number;
}

export const usePaginationRange = (props: PaginationRangeConfig) => {
  const {initialPage, currentPage} = props;

  const paginationRange = useMemo(
    () => range(initialPage, currentPage + 1),
    [currentPage, initialPage],
  );

  return paginationRange;
};

export const getNumerOfChunksPerPaginationPage = (
  tilesBeforeConsecutivelyDisplay: LoadMoreComponentDisplayConfig['tilesBeforeConsecutivelyDisplay'],
) => Math.ceil(tilesBeforeConsecutivelyDisplay / PRODUCTS_PER_PAGE);
